import _ from 'lodash';

export class AttributeHelper {
  static getTypologyAttributes(typology, locales, currentLocale, defaultLocale = null, show = true) {
    defaultLocale = defaultLocale || currentLocale;

    if (!typology?.attributes) return {};

    const attributesOut = {};
    const sortedAttributes = this.sortAttributes(typology.attributes);

    sortedAttributes.forEach(attribute => {
      attribute = this.handleListTypeAttributes(attribute, defaultLocale);
      attribute = this.handleFlagTypeAttributes(attribute);

      attribute = this.handleDefaultLabelLocal(attribute, defaultLocale);
      if (attribute.localized == 'true') {
        this.processLocalizedAttributes(attribute, locales, defaultLocale, attributesOut, show);
      } else {
        const attr = _.cloneDeep(attribute);
        attr.locale = locales;

        attribute.attributeLabel.forEach(attrLocals => {
          if (locales.includes(attrLocals.locale)) {
            attr.attributeName = attribute.attributeNameDefault;
          }
        });

        const key = attribute.mandatory;
        const media = attribute.attributeType;
        this.addAttributeToOutput(attr, key, attributesOut, media, currentLocale);
      }
    });

    return this.formatAttributesOutput(attributesOut);
  }

  static processLocalizedAttributes(attribute, locales, defaultLocale, attributesOut, show) {
    attribute.attributeLabel.forEach(attrLocals => {
      const defaultName = attribute.attributeNameDefault;
      locales.forEach(locale => {
        if (attrLocals.locale === locale) {
          const localizedAttribute = this.handleListTypeAttributes(attribute, locale, defaultName);
          this.addLocalizedAttributeToOutput(attrLocals, localizedAttribute, attributesOut, defaultName, show);
        }
      });
    });
  }

  static addLocalizedAttributeToOutput(attrLocals, attribute, attributesOut, defaultName, show) {
    const attr = _.cloneDeep(attribute);
    const attributeName = defaultName || attrLocals.attributeName;

    attr.attributeCode = `${attr.attributeCode}_${attrLocals.locale}`;
    attr.attributeNameWitoutLocal = attributeName;
    attr.attributeName = show ? `${attributeName} (${attrLocals.locale})` : attributeName;
    attr.locale = [attrLocals.locale];

    const key = attribute.mandatory;
    const media = attribute.attributeType;
    this.addAttributeToOutput(attr, key, attributesOut, media);
  }

  static addAttributeToOutput(attr, key, attributesOut, media, project = null) {
    const attributeKey = (media === 'MEDIA' || media === 'DOCUMENT' || media === 'PDF') ? 'MEDIA' : key;
    if (!attributesOut[attributeKey]) attributesOut[attributeKey] = [];
    attributesOut[attributeKey].push(attr);
  }

  static handleFlagTypeAttributes(attribute) {
    if (attribute.attributeType === 'FLAG') {
      const options = [{code: 'true', label: 'true'}, {code: 'false', label: 'false'}];
      attribute.options = options;
    }

    return attribute;
  }

  static handleListTypeAttributes(attribute, locale = null, defaultName = null) {
    if (attribute.attributeType === 'LIST' && attribute.lookupValues) {
      const options = attribute.lookupValues.map(value => {
        const localizedOption = locale
          ? value.lookupLabel.find(lookup => lookup.locale === locale)
          : value.lookupLabel[0];

        return { ...localizedOption, code: value.code };
      });
      attribute.options = options;
    }
    return attribute;
  }

  static formatAttributesOutput(attributesOut) {
    const formattedAttributes = [];

    for (const key in attributesOut) {
      attributesOut[key] = this.adjustWidths(attributesOut[key]);
      formattedAttributes.push(...attributesOut[key]);
    }

    return [attributesOut, formattedAttributes];
  }

  static sortAttributes(attributes) {
    return attributes.sort((a, b) => {
      const aCode = a.attributeCode.split('/')[0];
      const bCode = b.attributeCode.split('/')[0];

      if (aCode < bCode) return -1;
      if (aCode > bCode) return 1;
      if (aCode === bCode && a.attributeCode.includes('Unit')) return 1;

      return 0;
    });
  }

  static adjustWidths(attributes) {
    return attributes.map((attribute, index) => {
      const currentCode = attribute.attributeCode.split('/')[0];
      const nextCode = attributes[index + 1]?.attributeCode.split('/')[0];
      const prevCode = attributes[index - 1]?.attributeCode.split('/')[0];

      if (currentCode.includes('GRP') && (currentCode === nextCode || currentCode === prevCode)) {
        attribute.width = 6;
      } else {
        attribute.width = 12;
      }

      return attribute;
    });
  }


  static handleDefaultLabelLocal(attribute, defaultLocale) {
    attribute.attributeLabel.forEach(attrLocals => {
      if (attrLocals.locale === defaultLocale) {
        attribute["attributeNameDefault"] = attrLocals.label;
      }
    });

    if(attribute.lookupValues?.length > 0) {
      attribute.lookupValues.forEach((lookupValue) => {
        lookupValue.label = lookupValue.lookupLabel.filter((value) => value.locale === defaultLocale)[0]?.label;
        lookupValue.code = lookupValue.code;
      });
    }
    return attribute;
  }
}
